import BaseModel from './BaseModel';
import EquipmentMaintenance from './EquipmentMaintenance';
import Resource from './Resource';
import * as AT from '../../components/container/attributes';

export default class EquipmentMaintenanceResource extends BaseModel {
  constructor({
    id,
    resource = undefined,
    quantity = undefined,
    comment = undefined,
    equipmentMaintenance = undefined,
    sortOrder = undefined,
  }) {
    super(id, resource, quantity, comment, sortOrder);
    this.equipmentMaintenance = equipmentMaintenance
      ? new EquipmentMaintenance(equipmentMaintenance)
      : null;
  }
  static get fkName() {
    return 'equipment_maintenance_item_id';
  }
  static get apiRoute() {
    return 'equipment_maintenance_resource';
  }
  static get detailPageRoute() {
    return 'equipmentMaintenanceDetail';
  }
  static get listPageRoute() {
    return 'equipmentMaintenanceDetail';
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return EquipmentMaintenanceResource.fkName;
  }
  get apiRoute() {
    return EquipmentMaintenanceResource.apiRoute;
  }
  get detailPageRoute() {
    return EquipmentMaintenanceResource.detailPageRoute;
  }
  get listPageRoute() {
    return EquipmentMaintenanceResource.listPageRoute;
  }
  get createInitColumns() {
    return EquipmentMaintenanceResource.createInitColumns;
  }
  static get entityListDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation', 'quantity', 'comment'],
      ['resource'],
    );
  }
  static get allAttributes() {
    return [
      new AT.NotFetchedAttribute({
        name: 'number',
        readOnly: true,
        tableProperties: {
          readOnly: true,
          header: 'hit-app.common.number',
          maxWidth: '0.5fr',
        },
        transform: (data) => data?.resource?.number,
      }),
      new AT.NotFetchedAttribute({
        name: 'designation',
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.designation',
          maxWidth: '2fr',
          readOnly: true,
        },
        transform: (data) => {
          const res = new Resource(data?.resource);
          return res.designation;
        },
      }),
      new AT.FkEquipmentMaintenanceAttribute({
        name: 'equipmentMaintenance',
        column: 'equipment_maintenance_id',
        joinPath: ['equipment_maintenance!fk_equipment_maintenance_id'],
        tableProperties: {
          header: 'hit-app.common.equipment-maintenance',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'resource',
        fkToUpdate: 'resource_id',
        joinPath: [
          'resource!fk_equipment_maintenance_resource_resource_id_resource',
        ],
        tableProperties: {
          readOnly: 'true',
          header: 'hit-app.common.equipment-maintenance',
        },
      }),
      new AT.DecimalAttribute({
        name: 'quantity',
        decimalPrecision: 3,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.quantity',
          maxWidth: '0.75fr',
        },
      }),
      new AT.StringAttribute({
        name: 'comment',
        tableProperties: {
          header: 'hit-base.common.comment-short',
          maxWidth: '1.5fr',
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
      }),
    ];
  }
}
